import React from 'react';

import Form from '../../components/common/Form';
// import Joi from 'joi-browser';

class EmailModal extends Form {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            data: {
                email: props.email || "",
                new_email: ""
            },
            errors: {}
        };
    }

    // schema = {
    //     new_email: Joi.string().required().label("New email")
    // };
    doSubmit = (e) => {
        const data = this.state.data;
        this.props.acceptModal(null, data, null, null, 'change_email');
    };

    render() {
        let {visible_modal, onClickAway} = this.props;

        return (

            <div id="emailModal" className="modal in" style={visible_modal ? {display: "block"} : {display: "none"}}>
                {/*<div className="modal-content text-center">*/}
                {/*    <div className="onboarding-panel">*/}

                {/*        <h1 className="text-bold onboarding-title distribution-title m-m-b"><span>Change Email</span>*/}
                {/*        </h1>*/}
                {/*        <form onSubmit={this.handleFormSubmit}>*/}
                {/*            <div className="form-group m-m-b">*/}

                {/*                {this.renderInput("new_email", "New email", '', '', true, '', 'email')}*/}
                {/*            </div>*/}

                {/*            <div className="submit-buttons row">*/}
                {/*                <div className="col-md-6">*/}
                {/*                    <button disabled={false}*/}
                {/*                            onClick={onClickAway}*/}
                {/*                            name="cancel_email"*/}
                {/*                            id="cancel_email"*/}
                {/*                            type="button"*/}
                {/*                            className='btn-dark-blue'>Cancel*/}
                {/*                    </button>*/}
                {/*                </div>*/}
                {/*                <div className="col-md-6 text-right save-submit">*/}
                {/*                    {this.renderButton("Accept", "change_email", 'change_email', 'btn btn-action  edit-info ', false)}*/}

                {/*                    /!*<button disabled={false}*!/*/}
                {/*                    /!*        name="change_email"*!/*/}
                {/*                    /!*        id="change_email"*!/*/}
                {/*                    /!*        type="button"*!/*/}
                {/*                    /!*        onClick={this.doSubmit}*!/*/}
                {/*                    /!*        className='btn-action  edit-info ">Accept*!/*/}
                {/*                    /!*</button>*!/*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </form>*/}
                {/*    </div>*/}

                {/*</div>*/}
            </div>
        )
    }
}

export default EmailModal;